import { action, makeObservable, observable } from 'mobx';

class RoundsWinBetTypes {
  winBetTypes = [];

  constructor() {
    makeObservable(this, {
      winBetTypes: observable,
      setWinBetTypes: action.bound,
      updateWinBetTypes: action.bound,
    });
  }

  setWinBetTypes(winBetTypes) {
    this.winBetTypes = winBetTypes.reverse().filter((item, index) => index < 10);
  }

  updateWinBetTypes(roundInfo) {
    if (!this.winBetTypes.some((item) => roundInfo.roundId === item.roundId)) {
      this.winBetTypes = [roundInfo, ...this.winBetTypes];

      if (this.winBetTypes.length > 10) {
        setTimeout(() => {
          this.winBetTypes.pop();
        }, 480);
      }
    }
  }
}

export const roundsWinBetTypes = new RoundsWinBetTypes();
